module.exports = __webpack_public_path__ + "assets/avatar_hybrid.43cd3188.svg";